import { withI18n } from 'panda-i18n';
import locale from "../../locales";
import { attachPropertiesToComponent } from "../../utils/attach-properties-to-component";
import { CnRangeDatePickerPro, CnMonthPickerPro, CnYearPickerPro, CnWeekPickerPro, CnQuarterPickerPro, } from './view';
import { prompt } from './prompt';
import UICnDatePicker from './view/date-picker/date-picker';
UICnDatePicker.displayName = 'CnDatePickerPro';
var CnDatePicker = withI18n(UICnDatePicker, { locale: locale });
var CnDatePickerPro = attachPropertiesToComponent(CnDatePicker, {
    prompt: prompt,
});
CnDatePickerPro.displayName = 'CnDatePickerPro';
/**
 * @deprecated 请使用 CnRangeDatePickerPro 替换
 */
var CnDateRangePickerPro = CnRangeDatePickerPro;
CnDateRangePickerPro.displayName = 'CnDateRangePickerPro';
export { CnDatePickerPro, CnDatePickerPro as CnDatePicker, CnMonthPickerPro, CnYearPickerPro, CnWeekPickerPro, CnQuarterPickerPro, CnRangeDatePickerPro, CnDateRangePickerPro, };
